define('BluePoint.OrderTotalFix.Utils',
    [
        'underscore'
    ],
    function (
        _
    ) {

        'use strict';

        function getSchedule(line) {

            var schedule = null;

            /*
            CART / MINI CART STRUCTURE
            */

            if (line.item && line.item.extras &&
                line.item.extras.onlinecustomerprice_detail &&
                line.item.extras.onlinecustomerprice_detail.priceschedule
            ) {
                schedule = line.item.extras.onlinecustomerprice_detail.priceschedule;
            }

            /*
            CHECKOUT BACKBONE STRUCTURE
            */

            else if (line.get && line.get('item')) {

                var item = line.get('item');
                var itemData = item.attributes || item;

                if (itemData && itemData.extras &&
                    itemData.extras.onlinecustomerprice_detail &&
                    itemData.extras.onlinecustomerprice_detail.priceschedule
                ) {
                    schedule = itemData.extras.onlinecustomerprice_detail.priceschedule;
                }
            }

            return schedule;
        }

        function getQuantity(line) {

            if (line.quantity !== undefined) {
                return parseInt(line.quantity || 0, 10);
            }

            if (line.get) {
                return parseInt(line.get('quantity') || 0, 10);
            }

            return 0;
        }

        function getRate(line) {

            if (line.rate !== undefined) {
                return parseFloat(line.rate || 0);
            }

            if (line.get) {
                return parseFloat(line.get('rate') || 0);
            }

            return 0;
        }

        /*
        ORIGINAL / BASE PRICE
        FIRST ROW OF PRICE SCHEDULE
        */

        function getBasePrice(schedule) {

            if (!schedule || !schedule.length) {
                return 0;
            }

            return parseFloat(schedule[0].price || 0);
        }

        function getTier(schedule, totalQty) {

            if (!schedule || !schedule.length) {
                return null;
            }

            var selectedTier = null;

            _.each(schedule, function (tier) {

                var min = parseInt(tier.minimumquantity || 1, 10);
                var max = tier.maximumquantity
                    ? parseInt(tier.maximumquantity, 10)
                    : 999999;

                if (totalQty >= min && totalQty <= max) {
                    selectedTier = tier;
                }
            });

            return selectedTier;
        }

        function getTierPrice(schedule, totalQty) {

            var tier = getTier(schedule, totalQty);

            if (!tier) {
                return null;
            }

            return parseFloat(tier.price || 0);
        }

        function getNextTier(schedule, totalQty) {

            var nextTier = null;

            _.each(schedule, function (tier) {

                var min = parseInt(
                    tier.minimumquantity || 1,
                    10
                );

                if (min > totalQty) {

                    if (
                        !nextTier ||
                        min < parseInt(nextTier.minimumquantity, 10)
                    ) {
                        nextTier = tier;
                    }
                }
            });

            return nextTier;
        }

        function calculateTotals(lines) {

            var totalQty = 0;
            var frontendSubtotal = 0;
            var totalSavings = 0;
            var nextTierMessage = '';

            /*
            TOTAL CART QTY
            */

            _.each(lines, function (line) {
                totalQty += getQuantity(line);
            });

            /*
            PROCESS EACH LINE
            */

            _.each(lines, function (line) {

                var quantity = getQuantity(line);
                var schedule = getSchedule(line);
                var currentRate = getRate(line);

                /*
                FIX:
                Non quantity pricing items must still
                contribute to subtotal.
                */

                if (!schedule || !schedule.length) {

                    frontendSubtotal += (currentRate * quantity);

                    return;
                }

                /*
                CURRENT QUALIFIED TIER
                USING TOTAL CART QTY
                */

                var tier = getTier(schedule, totalQty);

                /*
                SAFETY FALLBACK
                */

                if (!tier) {

                    frontendSubtotal += (currentRate * quantity);

                    return;
                }

                var tierPrice = parseFloat(tier.price || 0);
                var basePrice = getBasePrice(schedule);

                /*
                IMPORTANT FIX
                If NetSuite already changed the rate
                to discounted price,
                use base price for savings calculation.
                */

                var originalRate;

                if (currentRate === tierPrice) {
                    originalRate = basePrice;
                } else {
                    originalRate = currentRate;
                }

                /*
                LINE TOTALS
                */

                var newAmount = tierPrice * quantity;
                var oldAmount = originalRate * quantity;

                frontendSubtotal += newAmount;
                totalSavings += (oldAmount - newAmount);

                /*
                NEXT TIER MESSAGE
                */

                var nextTier = getNextTier(schedule, totalQty);

                if (nextTier) {

                    var neededQty =
                        parseInt(nextTier.minimumquantity, 10) - totalQty;

                    nextTierMessage =
                        'Add ' + neededQty +
                        ' more item(s) to unlock the next discount tier.';
                }
            });

            return {
                totalQty: totalQty,
                frontendSubtotal: frontendSubtotal,
                totalSavings: totalSavings,
                nextTierMessage: nextTierMessage
            };
        }

        return {
            getSchedule: getSchedule,
            getQuantity: getQuantity,
            getRate: getRate,
            getBasePrice: getBasePrice,
            getTier: getTier,
            getTierPrice: getTierPrice,
            getNextTier: getNextTier,
            calculateTotals: calculateTotals
        };
    }
);
